import classNames from "classnames"
import { FunctionComponent, HTMLProps, PropsWithChildren } from "react"

export const LinkText: FunctionComponent<PropsWithChildren<HTMLProps<HTMLSpanElement>>> = ({
    children,
    className,
    ...rest
}) => {
    return (
        <span {...rest} className={classNames("hover:text-blue-500 hover:underline", className)}>
            {children}
        </span>
    )
}
